import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedService } from './../../shared/shared.service';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationMenuComponent implements OnInit {
	public userRole : string;
	public reportsMenu : Array <Object>;
	public isCollapsed : boolean = true;
	constructor(private sharedService : SharedService) { }
	ngOnInit() {		
	    this.userRole = this.sharedService.getUserRole();
	    this.sharedService.getReportsMenu().subscribe((response) => {
	      this.reportsMenu = response.result;	     
	    });
	}	
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/navigation-menu/navigation-menu.component.ts